import React from 'react';
import styles from './styles.module.css';

const Footer = () => (
  <footer className={styles.Footer}>
    <p>Copyright &copy; 2020 Felipe Rosa</p>
  </footer>
);

export default Footer;
